module.exports = __webpack_public_path__ + "img/new-reply.632e2572.png";